// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFunction } from '@ni/nimble-components/dist/esm/icons/function';
import { wrap } from '../utilities/react-wrapper';

export { type IconFunction };
export const NimbleIconFunction = wrap(IconFunction);